import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class ProductService {
    constructor(private http: HttpClient) { }

    private productService = environment.productService + "/v1";

    //********** Product APIs ************

    createProduct(payload: any): Observable<any> {
        console.log(payload);
        return this.http
            .post<any>(this.productService + "/product/add-product", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getProductList(
        payload: any,
        page: number,
        pageSize: number
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/product/fetch-product?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    updateProduct(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/product/update-product`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateProductVariant(payload: any): Observable<any> {
        return this.http
            .patch<any>(
                this.productService + `/product-variant/update-product-variant`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getByVariants(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + `/product-variants/get-by-ids`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    deleteProduct(productId: string): Observable<any> {
        return this.http
            .delete<any>(
                this.productService + `/product/delete-product/${productId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getProductById(productId: string): Observable<any> {
        return this.http
            .get<any>(
                this.productService + `/product/fetch-product/${productId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getProductsByIds(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + `/product/get-product-by-ids`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getAllProductVariants(
        payload: any,
        page: number,
        pageSize: number
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/product-variant/fetch-product-variant?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    checkSKU(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + `/product-variant/check-sku-exists`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    checkProductName(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/product/check-exists`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateProductStatusByCollectionId(payload: any): Observable<any> {
        return this.http
            .patch<any>(
                this.productService +
                `/product/update-productstatus-byCollectionId`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    increaseInventoryQuantity(payload: any): Observable<any> {
        return this.http
            .patch<any>(
                this.productService +
                `/product-variant/increase-quantity-cancel-order`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Brand API **************

    getBrand(payload: any, page: number, pageSize: number): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/brand/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    createBrand(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/brand`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateBrand(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/brand`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteBrand(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/brand/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getBrandById(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + `/brand/get/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    checkBrandExist(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/brand/check-exists`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateBulkBrand(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/brand/bulk-update`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Collection APIs ************

    getCollectionList(
        payload: any,
        page: number,
        pageSize: number
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/collection/fetch-collection?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getCollectionListByParentId(
        payload: any,
        page: number,
        pageSize: number
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/collection/fetch-collection-by-parentId?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    checkCollectionName(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + `/collection/check-exists`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    deleteCollection(collectionId: string): Observable<any> {
        return this.http
            .delete<any>(
                this.productService +
                `/collection/delete-collection/${collectionId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public addCollection(reqObj: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + "/collection" + "/add-collection",
                reqObj
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public updateCollection(reqObj: any): Observable<any> {
        return this.http
            .put<any>(
                this.productService + "/collection" + "/update-collection",
                reqObj
            )
            .pipe(catchError((err) => throwError(err)));
    }
    public updateBulkCollection(reqObj: any): Observable<any> {
        return this.http
            .put<any>(this.productService + "/collection/bulk-update", reqObj)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Tags APIs ************

    public getTag(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/tag/get-tag?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public addTag(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/tag", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public checkTag(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/tag/check-tag", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public deleteTag(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/tag/delete-tag/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Tax APIs ************

    public createTax(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/tax", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public getAllTax(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/tax/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public deleteTax(deleteId: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + "/tax/" + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    public getTaxById(editId: any): Observable<any> {
        return this.http
            .get<any>(this.productService + "/tax/get/" + editId)
            .pipe(catchError((err) => throwError(err)));
    }

    public updateTax(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + "/tax", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public checkDublicateTax(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/tax/check-exists", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    //********** Vendor APIs ************

    public addVendor(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/vendor/add-vendor", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public getAllVendor(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/vendor/get-vendors?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public updateVendor(payload: any): Observable<any> {
        return this.http
            .patch<any>(this.productService + "/vendor/update-vendor", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public deleteVendor(deleteId: any): Observable<any> {
        return this.http
            .delete<any>(
                this.productService + "/vendor/delete-vendor/" + deleteId
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public getVendorReport(): Observable<any> {
        return this.http
            .get<any>(this.productService + "/vendor/get-vendor-ledger")
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Export Import APIs ************

    public collectionExport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/collection/export", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    public productExport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/product/export", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public importBulkCollection(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/collection/import", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    public importBulkInventory(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/product-variant/import", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    public importBulkProduct(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/product/import", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    public inventoryExport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/product-variant/export", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Menu APIs ************

    createMenu(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/menu", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateMenu(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + "/menu", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateBulkMenu(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + "/menu/bulk-update-menu", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getAllMenu(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/menu/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getMenuByShopId(shopId: any): Observable<any> {
        return this.http
            .get<any>(this.productService + "/menu/getMenu/" + shopId)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Product Dashboard APIs ************

    getTotalProduct(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/product/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalCollection(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/collection/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getProductViewsGraph(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + "/views/productViewsGraph",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalViews(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/views/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getAverageViews(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/views/avg", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getTotalBrand(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/brand/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllBrands(): Observable<any> {
        return this.http
            .post<any>(this.productService + "/brand/get?page=1&pageSize=1000", {})
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Product Catalogue APIs ************

    createVideoCatalogue(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/videoCatalogue", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateVideoCatalogue(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + "/videoCatalogue", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getVideoCatalogue(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/videoCatalogue/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getVideoCatalogueById(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + "/videoCatalogue/get/" + id)
            .pipe(catchError((err) => throwError(err)));
    }
    deleteCatalogue(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + "/videoCatalogue/" + id)
            .pipe(catchError((err) => throwError(err)));
    }

    generateCataloguePdf(id: any): Observable<any> {
        return this.http
            .get<any>(
                this.productService +
                "/videoCatalogue/get-pdf-catalogue?id=" +
                id
            )
            .pipe(catchError((err) => throwError(err)));
    }

    //************** Catalogue API ***********
    public getCatalogue(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/customCatalogue/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public getCatalogueById(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + `/customCatalogue/get/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    public addCatalogue(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/customCatalogue", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public updateCatalogue(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + "/customCatalogue", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public bulkUpdateCatalogue(payload: any): Observable<any> {
        return this.http
            .put<any>(
                this.productService + "/customCatalogue/bulk-update",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public removeCatalogue(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/customCatalogue/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    public getCatalogueProductByCustomerId(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/customCatalogue/products-by-customer?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public getCatalogueVariantByCustomerId(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/customCatalogue/variants-by-customer?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public getCatalogueFilterCounts(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + `/customCatalogue/filter-counts`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    //product group

    public addProductGroup(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/productGroup", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public checkProductGroupExists(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.productService + "/productGroup/check-exists",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public getProductGroups(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/productGroup/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public deleteProductGroup(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/productGroup/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    public updateProductGroup(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/productGroup`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public getProductGroupById(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + `/productGroup/get/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    //composite product

    public createCompositeItem(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + "/compositeItem", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public getCompositeItem(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.productService +
                `/compositeItem/get-all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    public deleteCompositeItem(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/compositeItem/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    public updateCompositeItem(payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/compositeItem`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    public getCompositeItemById(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + `/compositeItem/get/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    getRelatedProducts(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + `/related-products/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    addRelatedProducts(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/related-products/`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateRelatedProducts(id: any, payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/related-products/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    deleteRelatedProducts(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/related-products/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    getsimilarProducts(id: any): Observable<any> {
        return this.http
            .get<any>(this.productService + `/similar-products/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    addsimilarProducts(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/similar-products/`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updatesimilarProducts(id: any, payload: any): Observable<any> {
        return this.http
            .put<any>(this.productService + `/similar-products/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getCart(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/cart/get-cart/criteria`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateCartNotes(payload: any): Observable<any> {
        return this.http
            .post<any>(this.productService + `/cart/update-cart-notes`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    deletesimilarProducts(id: any): Observable<any> {
        return this.http
            .delete<any>(this.productService + `/similar-products/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    //magic numbers
    getAllMagicNumberConfigs(): Observable<any> {
        return this.http
            .get<any>(`${this.productService}/magicNumbers/configs`)
            .pipe(catchError((error) => throwError(() => error)));
    }

    createMagicNumberConfig(payload: any): Observable<any> {
        return this.http
            .post<any>(`${this.productService}/magicNumbers/configs`, payload)
            .pipe(catchError((error) => throwError(() => error)));
    }

    updateMagicNumberConfig(id: string, payload: any): Observable<any> {
        return this.http
            .put<any>(
                `${this.productService}/magicNumbers/configs/${id}`,
                payload
            )
            .pipe(catchError((error) => throwError(() => error)));
    }

    deleteMagicNumberConfig(id: string): Observable<any> {
        return this.http
            .delete<any>(`${this.productService}/magicNumbers/configs/${id}`)
            .pipe(catchError((error) => throwError(() => error)));
    }
    getMagicNumberByName(config: any) {
        return this.http
            .post<any>(
                `${this.productService}/magicNumbers/configs/get-config`,
                config
            )
            .pipe(catchError((error) => throwError(() => error)));
    }
    // In your existing product.service.ts

    // Stocktaking Event APIs
    createStocktakingEvent(payload: any): Observable<any> {
        return this.http
            .post<any>(
                `${this.productService}/stock-taking/create-event`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getStocktakingEvents(payload: any): Observable<any> {
        return this.http
            .post<any>(
                `${this.productService}/stock-taking/get-events`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    updateStocktakingEntry(payload: any): Observable<any> {
        return this.http
            .post<any>(
                `${this.productService}/stock-taking/update-entry`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getStocktakingEntries(
        payload: any,
        page: number,
        pageSize: number
    ): Observable<any> {
        return this.http
            .post<any>(
                `${this.productService}/stock-taking/get-entries?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    deleteStocktakingEvent(eventId: string): Observable<any> {
        return this.http
            .delete<any>(
                `${this.productService}/stock-taking/delete-event/${eventId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    deleteStocktakingAssignment(assignmentId: string): Observable<any> {
        return this.http
            .delete<any>(
                `${this.productService}/stock-taking/delete-assignment/${assignmentId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    // product.service.ts
    transferStocktakingEntries(payload: any) {
        return this.http
            .post<any>(
                `${this.productService}/stock-taking/transfer-entries`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    createAssignment(assignmentData: any) {
        return this.http.post(
            `${this.productService}/stock-taking/create-assignment`,
            assignmentData
        );
    }

    getAssignments(
        criteria: any = {},
        page: number = 1,
        pageSize: number = 10
    ) {
        return this.http.post(
            `${this.productService}/stock-taking/get-assignments`,
            {
                ...criteria,
                query: { page, pageSize },
            }
        );
    }

    updateStocktakingProduct(assignmentId: string, productId: string, payload: any): Observable<any> {
        return this.http
            .put<any>(
                `${this.productService}/stock-taking/update-product/${assignmentId}/${productId}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    syncAssignmentBatches(assignmentId: string, productId?: string): Observable<any> {
        return this.http
            .put<any>(
                `${this.productService}/stock-taking/sync-assignment-batches/${assignmentId}`,
                { productId }
            )
            .pipe(catchError((err) => throwError(err)));
    }
}
